import React from 'react';

import { ILocaleText } from '@lib/tools/locale/views/LocaleFragment';

import * as S from '@components/web/src/atoms/ProductRating/ProductRating/styles';
import { Text } from '@components/web/src/foundations/Text/Text';
import { COLORS } from '@components/web/src/styles';

interface FeedbackTooltipProps {
  infoText: ILocaleText;
  isShowTooltip: boolean;
  isAnimated: boolean;
  isProductCardTooltip?: boolean;
}

export const RatingTooltip: React.FC<FeedbackTooltipProps> = ({
  infoText,
  isShowTooltip,
  isAnimated,
  isProductCardTooltip = false,
}) => {
  return (
    <>
      {isShowTooltip ? (
        <S.FeedbackTooltipContainer $isAnimated={isAnimated} $isProductCardTooltip={isProductCardTooltip}>
          <Text color={COLORS.base.white} size="body2" text={infoText} weight="semibold" />
          <S.Arrow />
        </S.FeedbackTooltipContainer>
      ) : null}
    </>
  );
};
